module.exports = __webpack_public_path__ + "static/img/1.692bb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/1.jpg
// module id = S8rF
// module chunks = 1